module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kent—1819")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("S")])]), _vm._v("he wouldn’t. She couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The words beat time to Frederica’s heartbeat. Pippin’s hooves picked up the rhythm and pounded it into hard-packed earth. The trees at the edge of her vision flung it back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The damp earthy smell of leaf mould filled her nostrils. Usually, she loved the dark scent. It spoke of winter and frost and warm fires. Today it smelled of decay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t. She wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would not wed Simon the slug. Not if her uncle begged her for the next ten years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ground softened as they rode through a clearing. Pippin’s flying hooves threw clods of mud against the walls of a dilapidated cottage hunched in the lee of the trees until a tunnel of low-hanging hazels on the other side seemed to swallow them whole. Frederica slowed Pippin to a walk, fearful of tree roots.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("At the river bank, she drew the horse up. Her secret place. The one spot on the Wynchwood estate where she ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("could be assured of peace and quiet and the freedom to think. A narrow stretch of soft green moss curled over the bank where the River Wynch carved a perfect arc in black loam. The trees on both sides of the water hugged close.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Barely ankle deep in summer, the winter flood rushed angrily a few inches below the bank, swirling and twisting around the deep pool in the crook of its elbow. Downstream, beyond Wynchwood Place’s ornamental lake, the river widened and turned listless, but here it ran fast, its tempo matching her mood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Breathless, cheeks stinging from the wind, she dismounted. Pippin dipped his head to slake his thirst. Satisfied he was content to nibble on the sedges at the water’s edge, she let his reins dangle and strolled a short way upstream. She stared into the ripples and swoops of impatient water, seeking answers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one could force her to wed Simon. Could they?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The casual mention of the plan by her uncle at breakfast had left her dumbfounded. And dumb. And by the time she had regained the use of her tongue, Uncle Mortimer had locked himself in his study.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did Simon know of this new turn of events? He’d never liked her. Barely could bring himself to speak to her when they did meet. It had to be a hum. Some bee in Uncle’s bonnet. Didn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If it wasn’t, they’d have to tie her in chains, hand and foot, blindfold her, gag her and even then she would never agree to marry her bacon-brained cousin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A small green frog, its froggy legs scissor-kicking against the current, aimed for the overhanging bank beneath her feet. She leaned over to watch it land.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What the devil do you think you are doing?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The deep voice jolted through her. Her foot slipped. She was going—")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Large hands caught her arms, lifted her, swung her around and set her on her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Heart racing, mouth dry, she spun about, coming face to face with a broad, naked chest, the bronzed skin covered in dark crisp curls and banded by sculpted muscle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The breath rushed from her lungs. Swallowing hard, she backed up a couple of steps and took in the dark savage gipsy of a man with hands on lean hips watching her from dark narrowed eyes. Hair the colour of burnt umber, shaded with streaks of ochre, fell to a pair of brawny shoulders. His hard slash of a mouth in his angular square-jawed face looked as if it had tasted of the world and found it bitter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fierce. Wild. Masculine. Intimidating. All these words shot through her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And frighteningly handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A tall rough-looking man, with the body of a Greek god and the face of a fallen angel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Heat spread out from her belly. Desire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A shiver ran down her spine. Her heart hammered. Her tongue felt huge and unwieldy. ‘Wh-who are you?’ Damn her stutter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Arrogant, controlled and powerful, he folded strong bare forearms over his lovely wide chest. He looked her up and down, assessing, without a flicker of a muscle in his impassive face. A dark questioning eyebrow went up. ‘I might ask the same of you,’ he said, his voice a deep low growl she felt low in her stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She clutched at the skirts of her old brown gown to hide the tremble in her hands and inhaled a deep breath. Every fibre of her being concentrated on speaking her next words without hesitation, without showing weakness. ‘I am Lord Wynchwood’s niece. I have every right to be here.’ Panting with effort, she released the remainder of her breath.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("He took a step towards her. Instinctively, she shrank ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("back. He halted, palms held out. ‘For God’s sake, you’ll end up in the river.’")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The exasperation in his tone and expression did more to ease her fears than soft words would have done. She glared at him. ‘Of c-course I w-won’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He backed up several paces. ‘Then move clear of the edge.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since he had ruined the solitude, shattered any hope for quiet contemplation, she might as well leave. Head high, she strode past him, carefully keeping beyond his arm’s length, and caught up Pippin’s reins. Prickles ran hot and painful down her back as if his dark gaze still grazed her skin. She couldn’t resist glancing over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d remained statue-still like some ancient Celtic warrior, bold and hard and simmering like a storm about to rage. A terrifyingly handsome man and thoroughly annoyed, though what he had to be annoyed about she couldn’t think.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How would he look if he smiled?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought surprised her utterly. ‘Wh-who are you, s-sir? W-what are you doing in these woods?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Robert Deveril, milady. Assistant gamekeeper. I live in the cottage yonder.’ He hesitated, pressed his lips together as if holding back something on the tip of his tongue. She knew the feeling only too well. Except for her, it was because it was easier to say nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And yet after a moment, he continued, ‘I thought your horse had bolted the way you tore past my house, but I see I was mistaken. Forgive me, milady.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suntanned fingers touched his forelock in a reluctant gesture of servility. If anything, he looked more arrogant than before. He pivoted and strode towards the path with long lithe strides.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("‘Y-your h-house?’ A recollection of flying dirt striking ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("something hollow filled her mind. No wonder he’d been surprised and come to see what was happening. Heat flashed upwards from her chest to the roots of her hair. ‘P-p-p—’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, tongue, don’t fail me now.")]), _vm._v(" She forced in a breath. ‘Mr D-Deveril,’ she called out.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He halted, then turned to face her, looking less than happy. ‘Milady?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I apologise.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It w-w-will not h-happen again.’ Mortified at her inability to express even the simplest of sentences when off-kilter, she turned to her mount. It wasn’t until the cinches on Pippin’s saddle disappeared in a blur that she realised she was close to crying and wasn’t sure why, unless it was frustration and the realisation of just how inconsiderate she’d been.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Let me help you, milady.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the sound of his deep, rich, oh-so-easy words, she almost swallowed her tongue. ‘G-g-go away,’ she managed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clinging to Pippin’s saddle, she turned her head. A good two feet away, he waited, calmly watching her, the anger still there, but contained, like that of the panther she’d once seen in a cage. Beautiful. And dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet she wasn’t afraid. She just didn’t want to look like a fool in front of this man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Look,’ he said reasonably, ‘I’m sorry I scared you. I thought you were in trouble when I saw you teetering on the brink. The rains have made the bank treacherous.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m a g-good s-s-swimmer.’ She tried a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s no jesting matter. No doubt you’d expect me to pull you out.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Simon’s face swam before her eyes like a pudgy Banquo’s ghost. ‘I’d prefer you didn’t bother.’")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes gleamed. Amusement? ‘My, you are in high ropes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was laughing at her. He saw her as a joke. A wordless fool. He was so perfect and she couldn’t string two words together. A spurt of resentment shot through her veins. ‘This was m-my p-place. You have s-spoiled it.’ She gulped in a supply of air. Her stutter was out of control. At any moment she’d been speechless. A dummy. For the second time today. ‘G-good d-day, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face blanched beneath his tan as if somehow she’d stabbed him and the blood had drained away. His hands fell to his sides, large hands that bunched into fists, knuckles gleaming white. ‘I beg your pardon, my lady.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An apology he scorned. She could see that in his expression.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She grabbed for Pippin’s reins. Tried to pull herself up. The horse sidled. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No, Pippin. Don’t do this now.")]), _vm._v(" ‘Shhh,’ she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A strong calloused hand grabbed the bridle beside her cheek. Her heart leapt into her throat at the size of it. Afraid her heart might jump right out of her mouth, she drew back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You’ll scare him,’ she warned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He murmured something. Pippin, the traitor, stilled. Deveril lifted the saddle flap and adjusted the cinch. He cocked a superior brow. ‘You were saying?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There it was, the arrogance of man. She breathed in slowly. ‘F-for an assistant gamekeeper you are very haughty.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Once more I find the need to apologise.’ A rueful grin curved his finely moulded lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Breathtaking. Heartstopping. A smile so dangerous ought to be against the law. Her anger whisked away as if borne aloft by the breeze tossing the branches above their ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("heads. All she could do was stare at his lovely mouth. She inhaled a shaky breath. ‘N-no. I was n-n…’ She swallowed, then closed her eyes, surprised when he didn’t finish the word. ‘I was not very polite. I am sorry.’")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He bowed his head in gentlemanly acknowledgement. ‘Can I help you mount, my lady?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since when did assistant gamekeepers have elegant manners and glorious bodies? Every time he spoke, her knees felt strangely weak and she just wanted to stand and look at him. He made her want things young ladies were not supposed to think about. She wanted to touch him. Trace the curve of muscle and the cords of sinew. Feel their warmth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And he wanted to help her onto her horse. ‘Thank you, Mr R-Robert Deveril.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes widened. ‘I must apologise for my earlier abruptness. I thought you an interloper.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I had not heard the cottage was let.’ She frowned. She’d barely stumbled on her words. ‘We d-d-don’t have an assistant gamekeeper.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I started on Monday.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one ever told her anything. ‘This is a lovely spot.’ She glanced around, drinking it in with a sense of sadness. She wouldn’t be able to come here any more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Aye, it is. Even at this time of year.’ Slivers of amber danced in his dark eyes like unspent laughter. He really was outstandingly beautiful, despite the day’s growth of beard. Or maybe because of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You are not from this part of the country, are you?’ she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An eyebrow flicked up. He smiled again, another swift curve of his mouth, instantly repressed, but still her skin went all hot and prickly. ‘I’m from the west. Dorset way.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("His accent had changed, broadened. He thought to trick ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("her, but she always noticed every word, every inflection, in other people’s voices. How could she not? This man hailed from London, and had been educated well, of that she was certain. She mentally shrugged. It mattered little to her where he came from. She prepared to mount.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Allow me,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He bent and linked his hands, then cast her a frowning look. ‘Don’t let me keep you from this place, milady. I shan’t disturb you again.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A furnace seemed to engulf her face. ‘Th-thank you. And it is not my lady, just plain Miss Bracewell.’ She caught herself lifting her chin and tucked it back in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His head tilted to one side as if considering her words, then his gaze slid away. ‘Yes, miss.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She placed one booted foot in his cupped hands and he tossed her up without effort.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tall and broad, straight and grand beside the horse, he planted his feet in the soft earth like a solid English oak. A man she would love to draw.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Naked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The wicked thought trickled heaviness to the dark, secret place she tried never to notice. Little flutters made her shift in the saddle. Wanton urges. The kind that led a woman into trouble. Her gaze drank him in. Her heart sank. Was it any wonder she felt this way, when Slimy Simon loomed in her future? ‘Good day, Mr Deveril.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wheeled Pippin around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t help looking back one last time. He raised a hand in farewell. Her heart gave a sweet little lurch, which once more set her stomach dancing.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("The horse broke into a trot and plunged into the trees. Robert could hear the sound of twigs snapping even as, utterly bemused, he followed in its wake. By the time he ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("reached the clearing, the spirited gelding and its rider had disappeared.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A strange little thing, this Miss Wynchwood. In her drab brown clothing, she reminded him of some wild woodland creature ready to run at a sound. Certainly no beauty—her eyes were too large, the colour changing with her thoughts from the bluish-grey of clouds to the grey-green of a wind-swept ocean. Her tragic mouth took up far too much of her pixie face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d wanted to kiss that mouth and make it tremble with desire instead of fear. He’d longed to release the tightly coiled hair at her nape and see it fall around her face. Pulled back, it did nothing to improve her looks. And yet she was oddly alluring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her style of conversation left much to be desired, though. Short and sharp and rude. Clearly a spoiled rich miss who needed a lesson in manners. Her Grace would not have tolerated such abruptness from one of Robert’s sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A dull stab of pain caught him off guard. Hades. Even now thoughts of home sneaked unwanted into his mind. He stared at the mud splattering the door of his cottage. What a reckless little cross-patch to ride at such speed through the woods. He groaned. And quite likely to report him to Lord Wynchwood for taking her to task.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damnation. What the hell had he said?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d been terrified she’d fall in the river, furious at her carelessness. He’d spoken harshly. He’d made her angry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Angry and woman did not mix well.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("He shouldered his way into the hut he called home and kicked the door shut. Damn, it was cold, but at least he had a roof over his head. He sorted through his bedclothes on the cot against the wall, found his jacket and shrugged into the coarse fabric. He stirred the embers to get the fire going and hung the kettle on the crane. He’d been making ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("tea moments before running outside because he thought the walls were collapsing. Moments before he’d ripped into the girl whose family owned these woods like a duke’s son instead of a servant. He’d been scathing when he should have thanked her for the honour her horse’s hooves had paid to his dwelling, or at least kept his tongue behind his teeth.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Such a small, fragile thing making all that rumpus. A good wind and she’d blow away. And when he boosted her on to her horse, she’d weighed no more than a child. Her eyes, though, had looked at him in the way of a woman. And his body had responded with interest. He cursed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was the best position he’d found in over two years and he’d be a fool to lose it because of a slip of a girl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stabbed the fire. Sparks flew. His nostrils filled with the scent of ashes. If he wasn’t mistaken, once he’d cooled down, he’d treated her the way he treated his sisters, with amused tolerance. No wonder she’d been annoyed. No doubt he’d be apologising tomorrow. Unless she had him turned off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blast. For the first time he’d found a place with a chance for advancement and enough wages to start paying off some of his debts and he’d scolded his employer’s niece.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Would he never come to terms with his new position in life?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He poured boiling water into the teapot and took it to the table set with a supper of bread and cheese. He cut a hunk of bread and skewered it with his knife. He took a bite and munched it slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If there was a next time, he’d be more careful. He’d remember his place.")])])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page36"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db938b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459202139_ch02.vue
// module id = 78
// module chunks = 0